import { render, staticRenderFns } from "./JustifiedList.vue?vue&type=template&id=ea935576&scoped=true&"
import script from "./JustifiedList.vue?vue&type=script&lang=js&"
export * from "./JustifiedList.vue?vue&type=script&lang=js&"
import style0 from "./JustifiedList.vue?vue&type=style&index=0&id=ea935576&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea935576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol})
